module.exports = __webpack_public_path__ + "static/media/onholdstamp.a6518369.svg";